import {
    RESET_DATA,

    GET_ACTIVATION_DISTRIBUTION_API,
    GET_ACTIVATION_DISTRIBUTION_API_SUCCESS,
    GET_ACTIVATION_DISTRIBUTION_API_FAILED,

    GET_ACTIVATION_DIST_CSV_API,
    GET_ACTIVATION_DIST_CSV_API_SUCCESS,
    GET_ACTIVATION_DIST_CSV_API_FAILED,

    GET_SIMBILLING_API,
    GET_SIMBILLING_API_SUCCESS,
    GET_SIMBILLING_API_FAILED,

    GET_SIMBILLINGCSV_API,
    GET_SIMBILLINGCSV_API_SUCCESS,
    GET_SIMBILLINGCSV_API_FAILED,

    GET_SIM_ACTIVATION_API,
    GET_SIM_ACTIVATION_API_SUCCESS,
    GET_SIM_ACTIVATION_API_FAILED,

    GET_SIM_ACTIVATION_CSV_API,
    GET_SIM_ACTIVATION_CSV_API_SUCCESS,
    GET_SIM_ACTIVATION_CSV_API_FAILED,

    GET_SIM_ACTIVATION_JIOPHONE_API,
    GET_SIM_ACTIVATION_JIOPHONE_API_SUCCESS,
    GET_SIM_ACTIVATION_JIOPHONE_API_FAILED,

    GET_SIM_ACTIVATION_JIOPHONE_CSV_API,
    GET_SIM_ACTIVATION_JIOPHONE_CSV_API_SUCCESS,
    GET_SIM_ACTIVATION_JIOPHONE_CSV_API_FAILED,

    GET_DAILY_ACTIVATING_OUTLET_API,
    GET_DAILY_ACTIVATING_OUTLET_API_SUCCESS,
    GET_DAILY_ACTIVATING_OUTLET_API_FAILED,

    GET_DAILY_ACTIVATING_OUTLET_CSV_API,
    GET_DAILY_ACTIVATING_OUTLET_CSV_API_SUCCESS,
    GET_DAILY_ACTIVATING_OUTLET_CSV_API_FAILED,

    GET_TOP_5_RETAILERS_API,
    GET_TOP_5_RETAILERS_API_SUCCESS,
    GET_TOP_5_RETAILERS_API_FAILED,

    GET_BOTTOM_5_RETAILERS_API,
    GET_BOTTOM_5_RETAILERS_API_SUCCESS,
    GET_BOTTOM_5_RETAILERS_API_FAILED,

    GET_LAST_7_DAYS_API,
    GET_LAST_7_DAYS_API_SUCCESS,
    GET_LAST_7_DAYS_API_FAILED,

    GET_LAST_7_DAYS_CSV_API,
    GET_LAST_7_DAYS_CSV_API_SUCCESS,
    GET_LAST_7_DAYS_CSV_API_FAILED,

    GET_CAF_PENDENCY_API,
    GET_CAF_PENDENCY_API_SUCCESS,
    GET_CAF_PENDENCY_API_FAILED,

    GET_CAF_PENDENCY_CSV_API,
    GET_CAF_PENDENCY_CSV_API_SUCCESS,
    GET_CAF_PENDENCY_CSV_API_FAILED,

    SHOW_ALERT_ACTIVATION,
    HIDE_ALERT_ACTIVATION,

    GET_SIM_ACT_METRICS_API,
    GET_SIM_ACT_METRICS_API_SUCCESS,
    GET_SIM_ACT_METRICS_API_FAILED
} from '../actions';
// import filterList from "../../resources/filterlist.json";
// import distList from "../../resources/distribution.json";
import { getTodaysDate } from "../../utils/common"
import config from "../../utils/config"
export const initialStateActivation = {
    segregatedData: [],
    filterValue: {
        selectedRegion: 'North',
        selectedState: 'Delhi',
        selectedRole: 'ZD - Shivalik Distribution Pvt Ltd - 0660002840',
        selectedRchain: '',
        selectedCategory: 'All',
        selectedPartnerRoleType: '754',
        selectedPartnerRoleName: 'ZD'
    },
    error: null,
    hierarchyData: null,
    mdnConnectivityData: null,
    headerSelectedDateFrom: getTodaysDate(config.startDate),
    headerSelectedDateTo: getTodaysDate(config.endDate),
    headerUnit: null,
    filteredArray: [],
    filterList: {
        loading: false,
        data: [],
        error: null
    },
    getAllAPI: {
        loading: false,
        data: {},
        error: null,
        deviceDistributionObject: {},
        simBillingObject: {},
        mdnConnectivityObject: {}
    },
    distributionObj: {
        loading: false,
        error: null,
        distributionTableData: {}
    },
    distCsvObj: {
        loading: false,
        error: null,
        csvData: {}
    },
    actCsvLoading: {
        Billed: false,
        OnBoarded: false,
        Primary: false,
        Secondary: false,
        Tertiary: false,
        simAct: false,
        daily: false,
        total: false,
        pending: false,
        rejected: false,
        last: false,
        JIOPHONE:false,
        SMARTPHONE:false,
        MNP:false
    },
    // simBillingObj: {
    //     loading: false,
    //     error: null,
    //     simBillingData: {}
    // },
    
    simBillingObj: {
                    loading: false,
                    error: null,
                    simBillingData: {                        
                        simBillingPrimary: {
                            loading: false,
                            error: null,
                            data: null
                            // data: state.simBillingObj.simBillingData.simBillingPrimary.data
                        },
                        simBillingSecondary: {
                            loading: false,
                            error: null,
                            data: null
                            // data: state.simBillingObj.simBillingData.simBillingSecondary.data
                        },
                        simBillingTertiary: {
                            loading: false,
                            error: null,
                            data: null
                            // data: state.simBillingObj.simBillingData.simBillingTertiary.data
                        },
                    }
                },

    simBillingCsvObj: {
        loading: false,
        error: null,
        simBillingCsvData: {}
    },
    simActivationObj: {
        loading: false,
        error: null,
        simActivationData: {}
    },
    simActivationCSVObj: {
        loading: false,
        error: null,
        simActivationCSVData: {}
    },
    simActivationJiophoneObj: {
        loading: false,
        error: null,
        simActivationData: []
    },
    simActivationJiophoneCSVObj: {
        loading: false,
        error: null,
        simActivationCSVData: {}
    },
    dailyActivatingOutletObj: {
        loading: false,
        error: null,
        dailyActivatingOutletData: {}
    },
    dailyActivatingOutletCSVObj: {
        loading: false,
        error: null,
        dailyActivatingOutletCSVData: {}
    },
    top5RetailersObj: {
        loading: false,
        error: null,
        top5RetailersData: {}
    },
    bottom5RetailersObj: {
        loading: false,
        error: null,
        bottom5RetailersData: {}
    },
    last7DaysObj: {
        loading: false,
        error: null,
        last7DaysData: {}
    },
    last7DaysCSVObj: {
        loading: false,
        error: null,
        last7DaysCSVData: {}
    },
    cafPendencyObj: {
        loading: false,
        error: null,
        cafPendencyData: {}
    },
    cafPendencyCSVObj: {
        loading: false,
        error: null,
        cafPendencyCSVData: {}
    },
    simActMetricsInsights: {
        loading: false,
        error: null,
        data: {},
        loadingKeys: {}
    },
    showAlert: false
};

export function activationSalesReducer(state = initialStateActivation, action) {
    switch (action.type) {
        case SHOW_ALERT_ACTIVATION: {
            return {
                ...state,
                showAlert: true
            }
        }
        case HIDE_ALERT_ACTIVATION: {
            return {
                ...state,
                showAlert: false
            }
        }
        case RESET_DATA:
            return {
                ...state,
                distributionObj: {
                    loading: false,
                    error: null,
                    distributionTableData: {}
                },
                // simBillingObj: {
                //     loading: false,
                //     error: null,
                //     simBillingData: {}
                // },
                simBillingObj: {
                    loading: false,
                    error: null,
                    simBillingData: {                        
                        simBillingPrimary: {
                            loading: false,
                            error: null,
                            data: {}
                            // data: state.simBillingObj.simBillingData.simBillingPrimary.data
                        },
                        simBillingSecondary: {
                            loading: false,
                            error: null,
                            data: {}
                            // data: state.simBillingObj.simBillingData.simBillingSecondary.data
                        },
                        simBillingTertiary: {
                            loading: false,
                            error: null,
                            data: {}
                            // data: state.simBillingObj.simBillingData.simBillingTertiary.data
                        },
                    }
                },
                simActivationObj: {
                    loading: false,
                    error: null,
                    simActivationData: {}
                },
                dailyActivatingOutletObj: {
                    loading: false,
                    error: null,
                    dailyActivatingOutletData: {}
                },
                top5RetailersObj: {
                    loading: false,
                    error: null,
                    top5RetailersData: {}
                },
                bottom5RetailersObj: {
                    loading: false,
                    error: null,
                    bottom5RetailersData: {}
                },
                last7DaysObj: {
                    loading: false,
                    error: null,
                    last7DaysData: {}
                },
                cafPendencyObj: {
                    loading: false,
                    error: null,
                    cafPendencyData: {}
                },
                simActMetricsInsights: {
                    loading: false,
                    error: null,
                    data: {},
                    loadingKeys: {}
                }

            }
        case GET_ACTIVATION_DISTRIBUTION_API:
            return {
                ...state,
                distributionObj: {
                    loading: true,
                    error: null,
                    distributionTableData: state.distributionObj.distributionTableData
                }
            }
        case GET_ACTIVATION_DISTRIBUTION_API_SUCCESS:
            let distTable = JSON.parse(JSON.stringify(state.distributionObj.distributionTableData));
            distTable[action.extraData] = [action.payload.content];
            return {
                ...state,
                distributionObj: {
                    loading: false,
                    error: null,
                    distributionTableData: Object.assign(state.distributionObj.distributionTableData, distTable)
                }
            }

        case GET_ACTIVATION_DISTRIBUTION_API_FAILED:
            return {
                ...state,
                distributionObj: {
                    loading: false,
                    error: action.error,
                    distributionTableData: {}
                }
            }
        case GET_ACTIVATION_DIST_CSV_API:
            return {
                ...state,
                distCsvObj: {
                    loading: true,
                    error: null,
                    csvData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: true
                }
            }

        case GET_ACTIVATION_DIST_CSV_API_SUCCESS:
            let distCsv = JSON.parse(JSON.stringify(state.distCsvObj.csvData));
            distCsv[action.extraData + '$' + action.tab] = [action.payload.content];
            return {
                ...state,
                distCsvObj: {
                    loading: false,
                    error: null,
                    csvData: Object.assign(state.distCsvObj.csvData, distCsv)
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }
        case GET_ACTIVATION_DIST_CSV_API_FAILED:
            return {
                ...state,
                distCsvObj: {
                    loading: false,
                    error: action.error,
                    csvData: {},
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }


        case GET_SIMBILLING_API:
            return {
                ...state,
                simBillingObj: {
                    loading: true,
                    error: null,
                    simBillingData: {   
                        simBillingPrimary: {
                            loading: (action.extraData === '/activation-sim-billing-primary' || 
                                        action.extraData === '/activation-sim-billing-secondary' ||
                                        action.extraData === '/activation-sim-billing-tertiary'
                                     ) && true ,
                            error: null,
                            data: null
                        },
                        simBillingSecondary: {
                            loading: (action.extraData === '/activation-sim-billing-secondary' ||
                                        action.extraData === '/activation-sim-billing-tertiary'
                                     ) && true , 
                            error: null,
                            data: null
                        },
                        simBillingTertiary: {
                            loading: action.extraData === '/activation-sim-billing-tertiary' && true ,
                            error: null,
                            data: null
                        },
                    }
                }
            }

        case GET_SIMBILLING_API_SUCCESS:
            let simBilling = JSON.parse(JSON.stringify(state.simBillingObj.simBillingData));
            
            if(action.extraData === '/activation-sim-billing-primary'){
                simBilling.simBillingPrimary.data = action.payload.content;
                simBilling.simBillingPrimary.loading = false;
            }
            else if(action.extraData === '/activation-sim-billing-secondary'){
                simBilling.simBillingSecondary.data = action.payload.content;
                simBilling.simBillingSecondary.loading = false;
            }
            else{
                simBilling.simBillingTertiary.data = action.payload.content;
                simBilling.simBillingTertiary.loading = false;
            }

            return {
                ...state,
                simBillingObj: {
                    loading: false,
                    error: null,
                    simBillingData: Object.assign(state.simBillingObj.simBillingData, simBilling)
                }
            }

        case GET_SIMBILLING_API_FAILED:
            let errorMsg = { [action.extraData]: [action.error] }
            return {
                ...state,
                simBillingObj: {
                    ...state.simBillingObj,
                    loading: false,
                    error: state.simBillingObj.error ? Object.assign(state.simBillingObj.error, errorMsg) : errorMsg,
                }
            }
        




        // case GET_SIMBILLING_API:
        //     return {
        //         ...state,
        //         simBillingObj: {
        //             loading: true,
        //             error: null,
        //             simBillingData: state.simBillingObj.simBillingData
        //         }
        //     }

        // case GET_SIMBILLING_API_SUCCESS:
        //     let simBilling = JSON.parse(JSON.stringify(state.simBillingObj.simBillingData));
        //     simBilling[action.extraData] = [action.payload.content]
        //     return {
        //         ...state,
        //         simBillingObj: {
        //             loading: false,
        //             error: null,
        //             simBillingData: Object.assign(state.simBillingObj.simBillingData, simBilling)
        //         }
        //     }

        // case GET_SIMBILLING_API_FAILED:
        //     let errorMsg = { [action.extraData]: [action.error] }
        //     return {
        //         ...state,
        //         simBillingObj: {
        //             loading: false,
        //             error: state.simBillingObj.error ? Object.assign(state.simBillingObj.error, errorMsg) : errorMsg,
        //             simBillingData: state.simBillingObj.simBillingData
        //         }
        //     }
            
        case GET_SIMBILLINGCSV_API:
            return {
                ...state,
                simBillingCsvObj: {
                    loading: true,
                    error: null,
                    simBillingCsvData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: true
                }
            }

        case GET_SIMBILLINGCSV_API_SUCCESS:
            let simBillingCsv = JSON.parse(JSON.stringify(state.simBillingCsvObj.simBillingCsvData));
            simBillingCsv[action.extraData] = [action.payload.content]
            return {
                ...state,
                simBillingCsvObj: {
                    loading: false,
                    error: null,
                    simBillingCsvData: Object.assign(state.simBillingCsvObj.simBillingCsvData, simBillingCsv)
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }

        case GET_SIMBILLINGCSV_API_FAILED:
            return {
                ...state,
                simBillingCsvObj: {
                    loading: false,
                    error: action.error,
                    simBillingCsvData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }

        case GET_SIM_ACTIVATION_API:
            return {
                ...state,
                simActivationObj: {
                    loading: true,
                    error: null,
                    simActivationData: state.simActivationObj.simActivationData
                }
            }

        case GET_SIM_ACTIVATION_API_SUCCESS:
            let simActivationAPIData = JSON.parse(JSON.stringify(state.simActivationObj.simActivationData));
            simActivationAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                simActivationObj: {
                    loading: false,
                    error: null,
                    simActivationData: Object.assign(state.simActivationObj.simActivationData, action.payload.content)
                }
            }

        case GET_SIM_ACTIVATION_API_FAILED:
            return {
                ...state,
                simActivationObj: {
                    loading: false,
                    error: action.error,
                    simActivationData: {}
                }
            }

        case GET_SIM_ACTIVATION_CSV_API:
            return {
                ...state,
                simActivationCSVObj: {
                    loading: true,
                    error: null,
                    simActivationCSVData: {}
                },
                actCsvLoading: {
                    [action.tab]: true
                }
            }
        case GET_SIM_ACTIVATION_CSV_API_SUCCESS:
            let simActivationCsvAPIData = JSON.parse(JSON.stringify(state.simActivationCSVObj.simActivationCSVData));
            simActivationCsvAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                simActivationCSVObj: {
                    loading: false,
                    error: null,
                    simActivationCSVData: Object.assign(state.simActivationCSVObj.simActivationCSVData, simActivationCsvAPIData)
                },
                actCsvLoading: {
                    [action.tab]: false
                }
            }
        case GET_SIM_ACTIVATION_CSV_API_FAILED:
            return {
                ...state,
                simActivationCSVObj: {
                    loading: false,
                    error: action.error,
                    simActivationCSVData: {}
                },
                actCsvLoading: {
                    [action.tab]: false
                }
            }
            case GET_SIM_ACTIVATION_JIOPHONE_API:
            return {
                ...state,
                simActivationJiophoneObj: {
                    loading: true,
                    error: null,
                    simActivationData: state.simActivationJiophoneObj.simActivationData
                }
            }

        case GET_SIM_ACTIVATION_JIOPHONE_API_SUCCESS:
            let simActivationJiophoneAPIData = JSON.parse(JSON.stringify(state.simActivationJiophoneObj.simActivationData));
            simActivationJiophoneAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                simActivationJiophoneObj: {
                    loading: false,
                    error: null,
                    simActivationData:action.payload.content
                }
            }

        case GET_SIM_ACTIVATION_JIOPHONE_API_FAILED:
            return {
                ...state,
                simActivationJiophoneObj: {
                    loading: false,
                    error: action.error,
                    simActivationData: {}
                }
            }

        case GET_SIM_ACTIVATION_JIOPHONE_CSV_API:
            return {
                ...state,
                simActivationJiophoneCSVObj: {
                    loading: true,
                    error: null,
                    simActivationCSVData: {}
                },
                actCsvLoading: {
                    [action.tab]: true
                }
            }
        case GET_SIM_ACTIVATION_JIOPHONE_CSV_API_SUCCESS:
            let simActivationJiophoneCsvAPIData = JSON.parse(JSON.stringify(state.simActivationJiophoneCSVObj.simActivationCSVData));
            simActivationJiophoneCsvAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                simActivationJiophoneCSVObj: {
                    loading: false,
                    error: null,
                    simActivationCSVData: Object.assign(state.simActivationJiophoneCSVObj.simActivationCSVData, simActivationJiophoneCsvAPIData)
                },
                actCsvLoading: {
                    [action.tab]: false
                }
            }
        case GET_SIM_ACTIVATION_JIOPHONE_CSV_API_FAILED:
            return {
                ...state,
                simActivationJiophoneCSVObj: {
                    loading: false,
                    error: action.error,
                    simActivationCSVData: {}
                },
                actCsvLoading: {
                    [action.tab]: false
                }
            }
        case GET_DAILY_ACTIVATING_OUTLET_API:
            return {
                ...state,
                dailyActivatingOutletObj: {
                    loading: true,
                    error: null,
                    dailyActivatingOutletData: state.dailyActivatingOutletObj.dailyActivatingOutletData
                }
            }

        case GET_DAILY_ACTIVATING_OUTLET_API_SUCCESS:
            let dailyActivatingOutletAPIData = JSON.parse(JSON.stringify(state.dailyActivatingOutletObj.dailyActivatingOutletData));
            dailyActivatingOutletAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                dailyActivatingOutletObj: {
                    loading: false,
                    error: null,
                    dailyActivatingOutletData: Object.assign(state.dailyActivatingOutletObj.dailyActivatingOutletData, action.payload.content)
                }
            }

        case GET_DAILY_ACTIVATING_OUTLET_API_FAILED:
            return {
                ...state,
                dailyActivatingOutletObj: {
                    loading: false,
                    error: action.error,
                    dailyActivatingOutletData: {}
                }
            }

        case GET_DAILY_ACTIVATING_OUTLET_CSV_API:
            return {
                ...state,
                dailyActivatingOutletCSVObj: {
                    loading: true,
                    error: null,
                    dailyActivatingOutletCSVData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: true
                }
            }
        case GET_DAILY_ACTIVATING_OUTLET_CSV_API_SUCCESS:
            let dailyActivatingOutletCsvAPIData = JSON.parse(JSON.stringify(state.dailyActivatingOutletCSVObj.dailyActivatingOutletCSVData));
            dailyActivatingOutletCsvAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                dailyActivatingOutletCSVObj: {
                    loading: false,
                    error: null,
                    dailyActivatingOutletCSVData: Object.assign(state.dailyActivatingOutletCSVObj.dailyActivatingOutletCSVData, dailyActivatingOutletCsvAPIData)
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }
        case GET_DAILY_ACTIVATING_OUTLET_CSV_API_FAILED:
            return {
                ...state,
                dailyActivatingOutletCSVObj: {
                    loading: false,
                    error: action.error,
                    dailyActivatingOutletCSVData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }
        case GET_TOP_5_RETAILERS_API:
            return {
                ...state,
                top5RetailersObj: {
                    loading: true,
                    error: null,
                    top5RetailersData: state.top5RetailersObj.top5RetailersData
                }
            }

        case GET_TOP_5_RETAILERS_API_SUCCESS:
            let top5RetailersAPIData = JSON.parse(JSON.stringify(state.top5RetailersObj.top5RetailersData));
            top5RetailersAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                top5RetailersObj: {
                    loading: false,
                    error: null,
                    top5RetailersData: Object.assign(state.top5RetailersObj.top5RetailersData, action.payload.content)
                }
            }

        case GET_TOP_5_RETAILERS_API_FAILED:
            return {
                ...state,
                top5RetailersObj: {
                    loading: false,
                    error: action.error,
                    top5RetailersData: {}
                }
            }

        case GET_BOTTOM_5_RETAILERS_API:
            return {
                ...state,
                bottom5RetailersObj: {
                    loading: true,
                    error: null,
                    bottom5RetailersData: state.bottom5RetailersObj.bottom5RetailersData
                }
            }
        case GET_BOTTOM_5_RETAILERS_API_SUCCESS:
            let bottom5RetailersAPIData = JSON.parse(JSON.stringify(state.bottom5RetailersObj.bottom5RetailersData));
            bottom5RetailersAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                bottom5RetailersObj: {
                    loading: false,
                    error: null,
                    bottom5RetailersData: Object.assign(state.bottom5RetailersObj.bottom5RetailersData, action.payload.content)
                }
            }
        case GET_BOTTOM_5_RETAILERS_API_FAILED:
            return {
                ...state,
                bottom5RetailersObj: {
                    loading: false,
                    error: action.error,
                    bottom5RetailersData: {}
                }
            }
        case GET_LAST_7_DAYS_API:
            return {
                ...state,
                last7DaysObj: {
                    loading: true,
                    error: null,
                    last7DaysData: state.last7DaysObj.last7DaysData
                }
            }
        case GET_LAST_7_DAYS_API_SUCCESS:
            let last7DaysAPIData = JSON.parse(JSON.stringify(state.last7DaysObj.last7DaysData));
            last7DaysAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                last7DaysObj: {
                    loading: false,
                    error: null,
                    last7DaysData: Object.assign(state.last7DaysObj.last7DaysData, action.payload.content)
                }
            }
        case GET_LAST_7_DAYS_API_FAILED:
            return {
                ...state,
                last7DaysObj: {
                    loading: false,
                    error: action.error,
                    last7DaysData: {}
                }
            }
        case GET_LAST_7_DAYS_CSV_API:
            return {
                ...state,
                last7DaysCSVObj: {
                    loading: true,
                    error: null,
                    last7DaysData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: true
                }
            }
        case GET_LAST_7_DAYS_CSV_API_SUCCESS:
            // let last7DaysCsvAPIData = JSON.parse(JSON.stringify(state.last7DaysCSVObj.last7DaysCSVData));
            // last7DaysCsvAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                // last7DaysCSVObj: {
                //     loading: false,
                //     error: null,
                //     last7DaysCSVData: Object.assign(state.last7DaysCSVObj.last7DaysCSVData, last7DaysCsvAPIData)
                // },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }
        case GET_LAST_7_DAYS_CSV_API_FAILED:
            return {
                ...state,
                last7DaysCSVObj: {
                    loading: false,
                    error: action.error,
                    last7DaysCSVData: {}
                },
                actCsvLoading: {
                    ...state.actCsvLoading,
                    [action.tab]: false
                }
            }
        case GET_CAF_PENDENCY_API:
            return {
                ...state,
                cafPendencyObj: {
                    loading: true,
                    error: null,
                    cafPendencyData: state.cafPendencyObj.cafPendencyData
                }
            }
        case GET_CAF_PENDENCY_API_SUCCESS:
            let cafPendencyAPIData = JSON.parse(JSON.stringify(state.cafPendencyObj.cafPendencyData));
            cafPendencyAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                cafPendencyObj: {
                    loading: false,
                    error: null,
                    cafPendencyData: Object.assign(state.cafPendencyObj.cafPendencyData, action.payload.content)
                }
            }
        case GET_CAF_PENDENCY_API_FAILED:
            return {
                ...state,
                cafPendencyObj: {
                    loading: false,
                    error: action.error,
                    cafPendencyData: {}
                }
            }
        case GET_CAF_PENDENCY_CSV_API:
            return {
                ...state,
                cafPendencyCSVObj: {
                    loading: true,
                    error: null,
                    cafPendencyData: {}
                },
                actCsvLoading: {
                    [action.tab]: true
                }
            }
        case GET_CAF_PENDENCY_CSV_API_SUCCESS:
            //let cafPendencyCsvAPIData = JSON.parse(JSON.stringify(state.cafPendencyCSVObj.cafPendencyCSVData));
            //cafPendencyCsvAPIData[action.extraData] = [action.payload.content];
            return {
                ...state,
                // cafPendencyCSVObj: {
                //     loading: false,
                //     error: null,
                //     cafPendencyCSVData: {}
                // }
                // cafPendencyCSVObj: {
                //     loading: false,
                //     error: null,
                //     cafPendencyCSVData: Object.assign(state.cafPendencyCSVObj.cafPendencyCSVData, cafPendencyCsvAPIData)
                // },
                actCsvLoading: {
                    [action.tab]: false
                }
            }
        case GET_CAF_PENDENCY_CSV_API_FAILED:
            return {
                ...state,
                cafPendencyCSVObj: {
                    loading: false,
                    error: action.error,
                    cafPendencyCSVData: {}
                },
                actCsvLoading: {
                    [action.tab]: false
                }
            }
        case GET_SIM_ACT_METRICS_API: {
            const key = action.extraData;
            const loadingKeys =
                key != null
                    ? { ...state.simActMetricsInsights.loadingKeys, [key]: true }
                    : state.simActMetricsInsights.loadingKeys;
            return {
                ...state,
                simActMetricsInsights: {
                    loading: true,
                    error: null,
                    data: state.simActMetricsInsights.data,
                    loadingKeys,
                },
            };
        }
        case GET_SIM_ACT_METRICS_API_SUCCESS: {
            const key = action.extraData;
            const newData =
                key != null
                    ? {
                          ...state.simActMetricsInsights.data,
                          [key]: action.payload,
                      }
                    : state.simActMetricsInsights.data;
            const loadingKeys =
                key != null ? { ...state.simActMetricsInsights.loadingKeys } : {};
            if (key != null && loadingKeys[key]) delete loadingKeys[key];
            const loading = Object.keys(loadingKeys).length > 0;
            return {
                ...state,
                simActMetricsInsights: {
                    loading,
                    error: null,
                    data: newData,
                    loadingKeys,
                },
            };
        }
        case GET_SIM_ACT_METRICS_API_FAILED: {
            const key = action.extraData;
            const err = action.error;
            const hasContentArray =
                typeof err?.content !== "undefined" && Array.isArray(err.content);
            const hasTrendsArray =
                typeof err?.trends !== "undefined" && Array.isArray(err.trends);
            const hasMtdLmtdPoints =
                typeof err?.mtd_lmtd_points !== "undefined" &&
                Array.isArray(err.mtd_lmtd_points);
            const isActuallySuccessPayload =
                key != null &&
                err != null &&
                typeof err === "object" &&
                !(err instanceof Error) &&
                (Array.isArray(err) ||
                    hasContentArray ||
                    hasTrendsArray ||
                    hasMtdLmtdPoints);
            const payloadData = isActuallySuccessPayload ? err : null;
            const newData =
                key != null && payloadData !== null
                    ? { ...state.simActMetricsInsights.data, [key]: payloadData }
                    : state.simActMetricsInsights.data;
            const loadingKeys =
                key != null ? { ...state.simActMetricsInsights.loadingKeys } : {};
            if (key != null) delete loadingKeys[key];
            const loading = Object.keys(loadingKeys).length > 0;
            return {
                ...state,
                simActMetricsInsights: {
                    loading,
                    error: isActuallySuccessPayload ? null : err,
                    data: newData,
                    loadingKeys,
                },
            };
        }
        default:
            return state;
    }
}

export default activationSalesReducer